import { isCefiInfoTx } from "@cede/types";
import { formatBalance } from "@cede/utils";
import { useSelectedTransaction } from "@/store/transaction/transaction";
import { ArrowRight } from "lucide-react";

export const SnackbarTradeInfo = () => {
  const { transaction, isTrade } = useSelectedTransaction(({ transaction, isTrade }) => ({
    transaction,
    isTrade,
  }));

  if (!transaction || !isTrade || !isCefiInfoTx(transaction.from) || !isCefiInfoTx(transaction.to)) return null;

  const { from, to } = transaction;

  return (
    <div className="flex items-center gap-1 mt-1">
      <p className="text-body2 text-cede-text-secondary">
        {formatBalance(from.transaction.amount)} {from.transaction.tokenSymbol}
      </p>
      <ArrowRight className="h-4 w-4 text-cede-text-secondary" />
      <p className="text-body2 text-cede-text-secondary">
        {formatBalance(to.transaction.amount)} {to.transaction.tokenSymbol}
      </p>
    </div>
  );
};
